/* Salt Coast — About page: road-line scroll fill + scroll reveal.
   Loaded by every sc-about-* section; runs once. */
(function () {
  if (window.__scAbout) return;
  window.__scAbout = true;
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && window.Shopify.designMode;

  function road() {
    var bar = document.querySelector('.sc-ab-road i');
    if (!bar) return;
    var h = doc.scrollHeight - window.innerHeight;
    bar.style.setProperty('--p', (h > 0 ? (window.scrollY / h) * 100 : 0) + '%');
  }
  window.addEventListener('scroll', road, { passive: true });
  window.addEventListener('resize', road);
  document.addEventListener('DOMContentLoaded', road);
  road();

  // Reveal: skipped in the theme editor and for reduced motion
  if (editor || reduce || !('IntersectionObserver' in window)) return;
  doc.classList.add('sc-ab-js');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 });
  function watch() {
    document.querySelectorAll('.sc-ab [data-rv]:not(.is-in)').forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
